import { Outlet } from 'react-router-dom'
import { useUser } from '@mfox/shared/contexts/UserContext'
import { AppFrame, STUDENT_BAR, studentProfileFor, studentTabsFor } from '@mfox/shared/ui/AppFrame'
import './app.css'

/** The student area's layout: the sidebar on a laptop, the bottom tab bar on a phone. MFox admins can open it too. */
export function AppShell() {
  const { currentUser } = useUser()

  return (
    <AppFrame tabs={studentTabsFor(currentUser?.role)} bar={STUDENT_BAR} navLabel="Sections" profileTo={studentProfileFor(currentUser?.role)}>
      <Outlet />
    </AppFrame>
  )
}
